import React, { useEffect, useMemo, useState, useRef } from "react";
import ReactQuill from "react-quill";
import Quill from "quill";
import "react-quill/dist/quill.snow.css";
// import "./NewMessage.css";
import "./NewUIMessage.css";
import { v4 as uuidv4 } from "uuid";
import "react-quill/dist/quill.snow.css";
import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "../../graphql/mutations";
import { Button, Container, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { InputForm } from "../InputForm/InputForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MessageType } from "./NewMessageType";
import { Checkbox } from "../Checkbox/Checkbox";
import { Notification } from "../Notification/Notification";
import { Heading, useAuthenticator, SwitchField } from "@aws-amplify/ui-react";
import Select from "react-select";
import { selectStyles } from "../EditPolicy/EditPolicyTypes";

import { BackButton } from "../_shared/Buttons/BackButton";
import { audiences } from "./Constants";

type OptionType = {
  value: string;
  label: string;
};

const Delta = Quill.import("delta");

export const actionOptions: OptionType[] = [
  { value: "topup", label: "Top-Up" },
  { value: "ti", label: "Travel Insurance" },
  { value: "referral", label: "Refer a friend" },
  { value: "converter", label: "Currency converter" },
];

export const colorOptions: OptionType[] = [
  { value: "default", label: "Default - navy" },
  { value: "red", label: "Red" },
  { value: "purple", label: "Purple" },
];

export const checkURLValid = (url: string): string | null => {
  const urlRegex =
    /\b(https?|ftp|file):\/\/[A-Za-z0-9+&@#%?=~_|!:,.;]*[A-Za-z0-9+&@#%=~_|]/;
  const match = url.match(urlRegex);
  if (match && match[1]) {
    return match[1];
  } else {
    return null;
  }
};

export const NewMessage = () => {
  const { signOut } = useAuthenticator();
  const [message, setMessage] = useState({
    id: uuidv4(),
    Title: "",
    Headline: "",
    Summary: "",
    Description: "",
    StartDate: new Date().toISOString(),
    EndDate: new Date().toISOString(),
    Active: false,
    TMCUsers: false,
    TIUsers: false,
    Renewals: false,
    GuestUsers: false,
    LoggedInUsers: false,
    AllUsers: false,
    Marketing: false,
    MatchAll: false,
    HasCTAButton: false,
    IsWebLink: false,
    WebLinkURL: "",
    ButtonLabel: "",
    CallToActionText: "",
    CallToActionType: "",
    CallToActionBtnColor: "default",
  } as MessageType);
  const [loading, setLoading] = useState(false);
  const [showCTAFields, setShowCTAFields] = useState(false);

  const [isWebLink, setIsWebLink] = useState(false);
  const [someOptionsDisabled, setSomeOptionsDisabled] = useState(false);
  const [startDate, setStartDate] = useState(new Date() as Date);
  const [endDate, setEndDate] = useState(new Date() as Date);
  const navigate = useNavigate();
  const timeout: number = 4000;
  const [toastTitle, setToastTitle] = useState("" as string);
  const [toastDescription, setToastDescription] = useState("" as string);
  const [showToast, setShowToast] = useState(false as boolean);
  const [selectedAudiences, setSelectedAudiences] = useState<string[]>([]);

  const isURLValid = checkURLValid(message?.WebLinkURL);

  const quillRef = useRef<ReactQuill | null>(null);

  const goBack = () => {
    navigate(-1);
  };

  const modules = useMemo(
    () => ({
      toolbar: [
        [
          {
            font: [],
          },
        ],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "link"],
        [{ list: "ordered" }, { list: "bulleted" }],
        [{ indent: -1 }, { indent: 1 }, { align: [] }],
        [],
      ],
      clipboard: {
        // will add the matcher after mount to keep this minimal
      },
    }),
    []
  );

  useEffect(() => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const ELEMENT_NODE = 1;
    quill.clipboard.addMatcher(ELEMENT_NODE, (_node, delta) => {
      const ops = delta.ops
        .map((op) => {
          if (typeof op.insert === "string") {
            return { insert: op.insert };
          }
          return null;
        })
        .filter(Boolean);
      return new Delta(ops as any);
    });
  }, []);

  const submit = async () => {
    const id = uuidv4();
    await API.graphql(
      graphqlOperation(mutations.createMessages, {
        messages: {
          id,
          ...message,
        },
      })
    );
    setShowToast(true);
    setToastTitle("Message Saved");
    setToastDescription(`Message with title: ${message?.Title} has been saved`);
    setTimeout(() => {
      navigate("/messages");
    }, timeout);
  };

  const handleSubmitMessage = async () => {
    setLoading(true);
    try {
      if (message.HasCTAButton) {
        if (isWebLink) {
          console.log("isWebLink = true");
          console.log("Message here", message);
          if (
            message.ButtonLabel?.length === 0 ||
            message.CallToActionBtnColor?.length === 0 ||
            message.WebLinkURL?.length === 0 ||
            !isURLValid
          ) {
            setShowToast(true);
            setToastTitle("Error!");
            setToastDescription(
              "Please ensure that all call-to-action fields are filled in, the weblink URL is valid and starts with http:// or https://"
            );
            return;
          } else {
            await submit();
          }
        } else {
          if (
            message.ButtonLabel?.length === 0 ||
            message.CallToActionText?.length === 0 ||
            message.CallToActionType?.length === 0 ||
            message.CallToActionBtnColor?.length === 0
          ) {
            setShowToast(true);
            setToastTitle("Error!");
            setToastDescription(
              "Please ensure that all call-to-action fields are filled in"
            );
            return;
          } else {
            await submit();
          }
        }
      } else {
        await submit();
      }
    } catch (e) {
      console.log(e);
      signOut();
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange = (selected) => {
    setMessage((message) => ({
      ...message,
      CallToActionText: selected.label,
      CallToActionType: selected.value,
    }));
    // if selected is referral or topup,
    // disable option for guest users and
    // all users from audience
    if (selected.value === "referral" || selected.value === "topup") {
      setSomeOptionsDisabled(true);
      audiences.forEach((audience) => {
        if (audience.name === "GuestUsers" || audience.name === "AllUsers") {
          const element = document.getElementsByName(
            audience.name
          )[0] as HTMLInputElement;
          if (element) {
            element.checked = false;
            element.disabled = true;
          }
        }
      });
      setMessage((message) => ({
        ...message,
        GuestUsers: false,
        AllUsers: false,
      }));
    } else {
      setSomeOptionsDisabled(false);
      audiences.forEach((audience) => {
        if (audience.name === "GuestUsers" || audience.name === "AllUsers") {
          const element = document.getElementsByName(
            audience.name
          )[0] as HTMLInputElement;
          if (element) {
            element.disabled = false;
          }
        }
      });
    }
  };

  const handleColorChange = (selected) => {
    setMessage((message) => ({
      ...message,
      CallToActionBtnColor: selected.value,
    }));
  };

  const handleChangeText = (value: string, name: string) => {
    const strippedValue = stripHTML(value);
    console.log("looking at stripped value " + strippedValue);
    setMessage((message) => {
      return {
        ...message,
        [name]: strippedValue,
      };
    });
  };

  const handleDescription = (value: string) => {
    setMessage((message) => {
      return {
        ...message,
        Description: value,
      };
    });
  };

  const handleStartDate = (value: Date) => {
    if (value) {
      setStartDate(value);
      let convertedStartDate = new Date(value);
      const startDateISOString = convertedStartDate.toISOString();
      setMessage((message: MessageType) => {
        return {
          ...message,
          StartDate: startDateISOString,
        };
      });
    }
  };

  const handleEndDate = (value: Date) => {
    setEndDate(value);
    const convertedEndDate = new Date(value);
    const endDateISOString = convertedEndDate.toISOString();
    setMessage((message: MessageType) => {
      return {
        ...message,
        EndDate: endDateISOString,
      };
    });
  };

  const handleSelectedEndDate = () => {
    if (startDate > endDate) {
      return startDate;
    } else {
      return endDate;
    }
  };

  const handleCheckValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const name = event.target.name;
    if (name !== "Active") {
      setSelectedAudiences((prev) =>
        checked ? [...prev, name] : prev.filter((item) => item !== name)
      );
    }
    setMessage((message) => {
      return {
        ...message,
        [name]: checked,
      };
    });
  };

  const handleCheckCallToAction = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;
    setShowCTAFields(!showCTAFields);
    setMessage((message) => {
      return {
        ...message,
        HasCTAButton: checked,
      };
    });
  };

  const handleCheckIsWebLink = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsWebLink(!isWebLink);
    setMessage((message) => {
      return {
        ...message,
        IsWebLink: checked,
      };
    });
  };

  const handleNotificationClose = () => {
    setShowToast(false);
  };

  const isAudienceSelected = selectedAudiences.length > 0;
  const disableButton = () => {
    if (
      message?.Title?.length === 0 ||
      message?.Headline?.length === 0 ||
      message?.StartDate?.length === 0 ||
      !isAudienceSelected
    ) {
      return true;
    } else {
      return false;
    }
  };

  const stripHTML = (html) => {
    console.log("trying to strip");
    let dbClient = new DOMParser().parseFromString(html, "text/html");
    return dbClient.body.textContent || "";
  };

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/messages");
  };

  const toastVariant = toastTitle === "Error!" ? "danger" : "success";

  return (
    <div>
      <Container fluid className="screenContainer">
        <div className="card message-card">
          {loading && <Spinner />}
          <BackButton onClick={onClick} label="Back to messages" />
          <Heading level={2} className="screen-title">
            Add New Message
          </Heading>
          <div className="formContainer">
            <div className="formItem">
              <InputForm
                name="Title"
                ariaLabel="Title"
                size="lg"
                inLineLabel
                onChange={handleChangeText}
                labelText="Title"
                controlId="formMessages"
                required={true}
                maxLength={100}
              />
            </div>
            <div className="formItem">
              <InputForm
                name="Headline"
                ariaLabel="Headline"
                required={true}
                size="lg"
                inLineLabel
                onChange={handleChangeText}
                labelText="Headline"
                controlId="formMessages"
              />
            </div>
            <div className="formItem">
              <InputForm
                name="Summary"
                ariaLabel="Summary"
                size="lg"
                inLineLabel
                onChange={handleChangeText}
                labelText="Summary"
                controlId="formMessages"
              />
            </div>

            <div className="formItem field-row field-row--top">
              <div className="field-label desc">Description</div>
              <div className="field-control">
                <ReactQuill
                  ref={quillRef}
                  modules={modules}
                  theme="snow"
                  className="rich-editor no-border"
                  onChange={handleDescription}
                />
              </div>
            </div>

            <div className="formItem field-row">
              <div className="field-label start">
                Start Date <span className="required">*</span>
              </div>
              <div className="field-control">
                <DatePicker
                  selected={startDate}
                  onChange={(date: Date) => handleStartDate(date)}
                  showTimeInput
                  showMonthDropdown
                  showYearDropdown
                  timeInputLabel="Time:"
                  dateFormat="dd/MM/yyyy h:mm aa"
                  className="date-input"
                />
              </div>
            </div>

            <div className="formItem field-row">
              <div className="field-label end">End Date</div>
              <div className="field-control">
                <DatePicker
                  selected={handleSelectedEndDate()}
                  onChange={(date: Date) => handleEndDate(date)}
                  minDate={startDate}
                  showTimeInput
                  showMonthDropdown
                  showYearDropdown
                  timeInputLabel="Time:"
                  dateFormat="dd/MM/yyyy h:mm aa"
                  className="date-input"
                />
              </div>

              <div className="checkbox-item">
                <Checkbox
                  label={"Is Active"}
                  name={"Active"}
                  className="action-checkbox"
                  handleCheck={handleCheckValue}
                />
              </div>
            </div>

            <div>
              <h3 className="audience-title">Action Button</h3>
              <div className="action-grid checkbox-item">
                <Checkbox
                  label={"Has call-to-action button"}
                  name={"HasCTAButton"}
                  className="action-checkbox"
                  handleCheck={handleCheckCallToAction}
                />
                {showCTAFields && (
                  <div className="inner-formItem">
                    <div className="inner-formItem field-row">
                      <p className="description-title">Is Weblink</p>
                      <SwitchField
                        name="subscribe-controlled"
                        label="Is Weblink"
                        isLabelHidden={true}
                        checked={isWebLink}
                        className="action-toggle"
                        onChange={handleCheckIsWebLink}
                      />
                    </div>
                    {isWebLink ? (
                      <div className="inner-formItem">
                        <InputForm
                          name="WebLinkURL"
                          ariaLabel="WebLinkURL"
                          size="lg"
                          inLineLabel
                          onChange={handleChangeText}
                          labelText="Web Link URL"
                          controlId="formMessages"
                          required={true}
                          onBlur={(e) => checkURLValid(e.target.value)}
                        />
                        {!isURLValid && message?.WebLinkURL && (
                          <p className="info-text-sentence">
                            URL is invalid. Please ensure it starts with http://
                          </p>
                        )}
                      </div>
                    ) : (
                      <div className="inner-formItem field-row">
                        <p className="description-title">Button Action</p>
                        <Select
                          defaultValue={{
                            value: "",
                            label: "Please select a call-to-action",
                          }}
                          options={actionOptions}
                          styles={selectStyles}
                          className="select-feild"
                          onChange={handleSelectChange}
                        />
                      </div>
                    )}
                    <div className="inner-formItem field-row">
                      <p className="description-title">Button Colour</p>
                      <Select
                        defaultValue={{
                          value: "",
                          label: "",
                        }}
                        options={colorOptions}
                        styles={selectStyles}
                        className="select-feild"
                        onChange={handleColorChange}
                        placeholder="Please select a colour"
                      />
                    </div>
                    <div className="inner-formItem">
                      <InputForm
                        name="ButtonLabel"
                        ariaLabel="ButtonLabel"
                        size="lg"
                        inLineLabel
                        onChange={handleChangeText}
                        labelText="Button Label"
                        controlId="formMessages"
                        required={true}
                        maxLength={15}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <h3 className="audience-title">Target Audience</h3>
            {someOptionsDisabled && (
              <p className="info-text-audience">
                Some options are disabled for this action button as those users
                have restricted access to selected feature
              </p>
            )}
            <div className="audience-grid checkbox-list">
              {audiences.map(({ label, name }) => (
                <Checkbox
                  key={name}
                  label={label}
                  name={name}
                  handleCheck={handleCheckValue}
                />
              ))}
            </div>

            <div className="button-wrapper-new actions">
              <Button
                variant="primary"
                type="submit"
                className="btn-save"
                disabled={disableButton()}
                onClick={handleSubmitMessage}
              >
                Save
              </Button>
              <Button
                type="button"
                variant="outline-secondary"
                className="tn-cancel"
                onClick={goBack}
              >
                Cancel
              </Button>
            </div>

            <div className="notification-wrapper">
              <Notification
                show={showToast}
                timer={timeout}
                position="top-center"
                title={toastTitle}
                description={toastDescription}
                autohide={true}
                handleClose={handleNotificationClose}
                variant={toastVariant}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
